export default __webpack_public_path__ + "static/media/howtouse_basic_04_ko.d4d2921d.png";